import { Injectable } from '@angular/core';
import {getCookie} from "../helpers/utils";
import {HttpClient} from "@angular/common/http";

const API_URL = '/api/v1/tournament_bracket_generation_type';
@Injectable({
  providedIn: 'root'
})
export class GridPlayersManagementTypeService {

  constructor(private http: HttpClient) { }
  private getCsrfToken(): string {
    return getCookie('csrftoken');
  };

  setUpPlayersManagementType(type, tournamentId) {
    return this.http.post(
      `${API_URL}/?&tournament_id=${tournamentId}`,
      {
        bracket_generation_type: type,
        tournament_id: tournamentId,
      },
      {
        headers: {
          'X-CSRFToken': this.getCsrfToken(),
        },
      }
    )
  }
}
